import AcxChip from "components/UI/AcxChip";
import { EmissionRecordType } from "models/Emissions";
import React from "react";

export type EmissionsConfigurationType = "endpoint" | "body";

export const ConfigurationTypeChip: React.FC<{
    type: EmissionsConfigurationType;
}> = ({ type }) =>
    type === "endpoint" ? (
        <AcxChip size="small" color="blue" label="Endpoint" />
    ) : (
        <AcxChip size="small" color="lightBlue" label="Emission Body" />
    );

export const ConfigurationStatusChip: React.FC<{ isActive: boolean }> = ({
    isActive,
}) =>
    isActive ? (
        <AcxChip size="small" color="green" label="Active" />
    ) : (
        <AcxChip size="small" color="gray" label="Disabled" />
    );

const recordTypeChips: Record<
    EmissionRecordType,
    { label: string; color: "green" | "red" | "blue" }
> = {
    Receipt: { label: "Receipt", color: "green" },
    Failure: { label: "Failure", color: "red" },
    RulesFilterEvaluation: { label: "Rule Filter Eval", color: "blue" },
};

export const RecordTypeChip: React.FC<{ type: EmissionRecordType }> = ({
    type,
}) => (
    <AcxChip
        size="small"
        color={recordTypeChips[type].color}
        label={recordTypeChips[type].label}
    />
);
